import anime from 'animejs';
import { createAnimation } from '@/assets/js/utils/createAnimation';
import { characterWalk } from '@/assets/js/utils/characterWalk';
import { createRotateAnimation } from '@/assets/js/utils/createRotateAnimation';

const aye_animations = () => {
  return {
    enter(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 4000
        tl
          .add({
            targets: '#aye',
            translateY: characterWalk(options.duration),
            left: ['-20%', '0%'],
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    exit(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        tl.add({
          targets: '#aye',
          left: ['57%', '130%'],
          translateY: characterWalk(options.duration),
          easing: 'linear',
          duration: options.duration,
          begin: options.begin,
          complete: options.complete
        })
      }, options, this)()
    },
    spinAndWalk(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        tl
          .add({
            targets: '#aye',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip aye conditionally
            left: options.left, // gradually move closer to left side of scene.
            translateY: characterWalk(options.duration),
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    walk(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        tl
          .add({
            targets: '#aye',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip aye conditionally
            left: options.left, // gradually move closer to left side of scene.
            translateY: characterWalk(options.duration),
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    // Turns around in place
    flip(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        tl
          .add({
            targets: '#aye',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip aye conditionally
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    // Raises both the upper arm and forearm
    raiseRightArm(options) {
      return createAnimation((tl, options) => {
        tl
        .add({
          targets: '#aye_right_arm_hand',
          rotate: '-105deg',
          easing: 'linear',
          duration: 500,
          begin: options.begin,
          complete: options.complete
        })
      }, options, this)()
    },
    // Raises forearm only
    raiseRightForeArm(options) {
      return createAnimation((tl, options) => {
        tl
        .add({
          targets: '#aye_left_arm_hand',
          rotate: '-100deg',
          easing: 'linear',
          duration: 500,
          begin: options.begin,
          complete: options.complete
        })
        // .add({
        //   targets: '#aye_left_arm',
        //   rotate: '0deg',
        //   easing: 'linear',
        //   duration: 500,
        //   complete: options.complete
        // })
      }, options, this)()
    },
    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_right_arm_hand',
            rotate: '0deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: '#aye_right_arm',
            rotate: '0deg',
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    raiseLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_left_arm',
            rotate: '-40deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-90deg',
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    raiseLeftForeArm(options) {
      return createAnimation((tl, options) => {
        tl
        .add({
          targets: '#aye_left_arm_hand',
          rotate: '-100deg',
          easing: 'linear',
          duration: 500,
          begin: options.begin,
          complete: options.complete
        })
        .add({
          targets: '#aye_left_arm',
          rotate: '0deg',
          easing: 'linear',
          duration: 500,
          complete: options.complete
        })
      }, options, this)()
    },
    lowerLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '0deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: '#aye_left_arm',
            rotate: '0deg',
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    handShake(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_right_arm',
            rotate: '-35deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: '#aye_right_arm_hand',
            rotate: '-60deg',
            easing: 'linear',
            duration: 500,
          })

          // handshake
          .add({
            targets: '#aye_right_arm_hand',
            rotate: '-48deg',
            easing: 'linear',
            duration: 500,
          })
          .add({
            targets: '#aye_right_arm_hand',
            rotate: '-60deg',
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    scratchHead(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: '#aye_left_arm',
            rotate: '-130deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-120deg',
            easing: 'easeOutCubic',
            duration: 700,
            offset: '-=100', // start forearm movement right before upper arm completes
          })

          // move forearm up/down
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-130deg',
            easing: 'easeOutCubic',
            duration: 500,
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-120deg',
            easing: 'easeOutCubic',
            duration: 500,
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-130deg',
            easing: 'easeOutCubic',
            duration: 500,
          })
          .add({
            targets: '#aye_left_arm_hand',
            rotate: '-120deg',
            easing: 'easeOutCubic',
            duration: 500,
            complete: options.complete
          })

      }, options, this)()
    }
  }
}

export { aye_animations }



// WEBPACK FOOTER //
// ./src/components/module_5/js/aye_animations.js